import React, { useEffect, useRef } from 'react';
import Step1Overview from '../overview/step-1-overview';
import Step1MobileHeader from './step-1-mobile-header';
import Step1ProductsListDesktop from './products-list/step-1-products-list-desktop';
import Step1ProductsListMobile from './products-list/step-1-products-list-mobile';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { sendGaCheckoutEvent } from '../../../../../domain/marketing/gtm-provider';
import { CartSteps } from '../../enums/cart-steps';
import SavedForLater from '../saved-for-later/saved-for-later';
import { getABTest, sendABTestAnalytics } from '../../../../../domain/abtest/abtest-provider';
import { sendTiktokInitiateCheckout } from '../../../../../domain/marketing/tiktok-provider';
import { isEqual } from 'lodash';

/**
 * Shopping Cart Step #1.
 */
const CartStep1 = () => {

    const dispatch = useAppDispatch();

    const cartData = useAppSelector(store => store.root.cartData, isEqual);
    const cartStep = useAppSelector(store => store.root.cartStep);

    /**
     * https://wavesaudio.atlassian.net/browse/DSWEB-3348
     */
    useEffect(() => {
        sendGaCheckoutEvent(CartSteps.First, cartData);
    },
        // eslint-disable-next-line
        []
    );

    /**
     * https://wavesaudio.atlassian.net/browse/DSWEB-5227
     * yes:50, no:50
     */
    useEffect(() => {
        const abtest = getABTest('CartOnSale');
        if(!abtest?.isActive ||
            !cartData?.cartItems?.length ||
            cartStep !== CartSteps.First) return;

        let hasSaleItems = false;

        for(const cartItem of cartData.cartItems) {
            if(!cartItem.isActive || !cartItem.priceData?.showMSRPPrice) continue;
            hasSaleItems = true;
            break;
        }

        if(!hasSaleItems) return;

        sendABTestAnalytics(abtest);

        dispatch(
            rootActions.main({
                cartOnSaleABTestStep1TextShown: abtest.selected === 'yes',
            })
        )
    }, [
        dispatch,
        cartStep,
        cartData,
    ]);

    const hasSentRef = useRef(false);
    useEffect(() => {
        if (hasSentRef.current || !cartData?.cartItems?.length) return;

        hasSentRef.current = true;

        sendTiktokInitiateCheckout(cartData);
        window.wBraze?.logCheckoutStartedEventFromCartData(cartData);
    }, [
        cartData,
    ]);

    return (
        <>
            <Step1MobileHeader />

            <div className="flex flex-wrap w-full pb-10">

                <Step1ProductsListDesktop showYouMayAlsoLike={ false } />
                <Step1ProductsListMobile />

                <Step1Overview />
            </div>


            { /* mobile only - you may also like */ }
            { /*
                showYouMayAlsoLike &&
                <div className="w-full md:hidden mb-6">
                    <YouMayAlsoLike />
                </div>
                */
            }

            {
                /* mobile only - saved for later */
                cartData.wishListData && cartData.wishListData.length > 0 &&
                <div className="w-full md:hidden mb-6">
                    <SavedForLater />
                </div>
            }

        </>
    )
};

export default CartStep1;